// DS: IL3
// from GDrive
import React from 'react';
export class SheetUnlocked extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "88",
            height: "88",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ React.createElement("g", {
            fill: "#000"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M53 38H28c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM28 32h10c.55 0 1-.45 1-1s-.45-1-1-1H28c-.55 0-1 .45-1 1s.45 1 1 1zM53 46H28c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM48 54H28c-.55 0-1 .45-1 1s.45 1 1 1h20c.55 0 1-.45 1-1s-.45-1-1-1zM45 64c.55 0 1-.45 1-1s-.45-1-1-1H28c-.55 0-1 .45-1 1s.45 1 1 1h17z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M19 18h29v14h14v15h2V30.59L49.41 16H17v60h32v-2H19V18zm31 1.41L60.59 30H50V19.41z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M82 58v-1c0-3.86-3.14-7-7-7s-7 3.14-7 7v1H52v18h22V58h8zm-12-1c0-2.76 2.24-5 5-5s5 2.24 5 5v1H70v-1zm2 17H54V60h18v14z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M63 62c-2.21 0-4 1.79-4 4 0 1.86 1.28 3.41 3 3.86V71c0 .55.45 1 1 1s1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86 0-2.21-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        })));
    }
}
